import { Navigate, useLocation } from 'react-router';
import { useAuth } from './AuthContext';
import { AUTH_PATHS } from '@/feature/authentication/constants';
import { useMfa } from '@/feature/authentication/MfaContext';
import { useMfaSetupGuard } from '@/feature/authentication/hooks/useMfaSetupGuard';

interface PublicRouteProps {
  children: React.ReactNode;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { isAuthenticated, isLoading: authLoading, user } = useAuth();
  const location = useLocation();
  const { mfaVerificationMode } = useMfa();
  const { data: mfaGuard } = useMfaSetupGuard(user?.email);

  const needsMfaSetup = mfaGuard?.setupRequired === true;
  const isPhoneSetupRoute =
    location.pathname === AUTH_PATHS.MFA_SETUP_PHONE ||
    (location.pathname === AUTH_PATHS.MFA_VERIFICATION &&
      mfaVerificationMode === 'phone-setup');

  if (
    isAuthenticated &&
    !authLoading &&
    !(needsMfaSetup && isPhoneSetupRoute)
  ) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
